import ActionsContainer from "../../../Pages/EditProduct/Components/ActionsContainer";
import Button from "@material-ui/core/Button";
import ToolbarContainer from "../../../Pages/EditProduct/Components/ToolbarContainer";
import React, {useMemo} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "./AppBar";
import TemplatePage from "./TemplatePage";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {ACTIONS, getPartRefById, getUserTextResourcesByPartRef} from "../../../../Providers/TemplateInstanceProvider";
import {Trans, useTranslation} from "react-i18next";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import ToolbarContent from "../../../Pages/EditProduct/Components/ToolbarContent";
import {ToolbarOption, ToolbarOptions} from "../../../Pages/EditProduct/Components/ToolBarOptions";
import TemplateContainer from "./TemplateContainer";

const useStyles = makeStyles(theme => ({
    mainContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    button: {
        width: '64px',
        height: '64px',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}))

export default ({product, userImages, changeMenu}) => {
    const classes = useStyles();
    const [state, dispatch] = useTemplateInstance();
    const {t} = useTranslation();

    const texts = useMemo(() => {
        const partRef = getPartRefById(state.currentPartRefId, state.template)
        return getUserTextResourcesByPartRef(partRef, state)
            .filter(resource => !resource.disableEdit);
    }, [state]);

    const selectResource = (e, resource) => {
        dispatch({
            type: ACTIONS.SET_CURRENT_RESOURCE,
            id: resource.fullId
        })
        changeMenu('text')
    }


    return <div className={classes.mainContainer}>
        <AppBar onCancel={() => changeMenu('main')} />

        <TemplateContainer handleUserStringClick={selectResource}
                           mode={'select-user-text'}
        />

        <ToolbarContainer>
            <ToolbarContent>
                <ToolbarOptions header={t('Choose text')}>
                    {texts.map( (resource, index) => {
                        return <ToolbarOption key={resource.id}
                                              content={index + 1}
                                              onClick={e => selectResource(e, resource)} />
                    })}
                </ToolbarOptions>
            </ToolbarContent>

            <ActionsContainer>
                <Button color="primary" onClick={() => changeMenu('main')}><Trans>Cancel</Trans></Button>
                <Button color="primary" onClick={() => changeMenu('main')}><Trans>Done</Trans></Button>
            </ActionsContainer>
        </ToolbarContainer>
    </div>
}